module.exports = "/assets/data/482da0be89537918cc0bb26863987b66-SM7.data.json";